import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconMute({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `edu-icon edu-icon--${size} ${className}`;
  return <>{!!srText && <span className='sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" aria-hidden="true" role="img" className={newClassName} {...props}><g fill="currentColor"><path d="m10.559 17.26-5.413-3.907H.5V6.647h4.646L10.56 2.74zM13.912 6.128a4.47 4.47 0 0 1 0 7.744l-.67-1.162a3.128 3.128 0 0 0 0-5.42z" /><path d="M15.588 3.225a7.823 7.823 0 0 1 0 13.55l-.66-1.143a6.503 6.503 0 0 0 0-11.264z" /></g></svg></>;
}
export default IconMute;